//@flow
import React from 'react';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';

type Props = {
  inUS?:boolean,
  quoteTotals:QuoteTotalsModel,
};

function getShippingIncentive(props:Props) {
  if (!props.quoteTotals.getSubtotal()) return null;

  const buyMoreAmt = props.quoteTotals.getAmountToFreeShipping();

  if (buyMoreAmt) {
    return (
      <div className="buy-more">
        {`Add $${buyMoreAmt.toFixed(2)} for free delivery!`}
      </div>
    );
  }

  return null;
}

export default function ShippingPrice(props:Props) {
  if (!props.inUS || !props.quoteTotals) return null;

  const salesGoal = props.quoteTotals.getMinimumFreeShipping() || 0;
  const subtotal = props.quoteTotals.getSubtotal() || 0;

  if (subtotal === 0) {
    return (
      <div className="sales-goal">
        {`Free delivery on orders over $${salesGoal.toFixed(2)}`}
      </div>
    );
  }

  if (props.quoteTotals.getAmountToFreeShipping()) {
    return getShippingIncentive(props);
  }

  return (
    <div className="sales-goal">
      Your delivery is free!
    </div>
  );

}
